module.exports = __webpack_public_path__ + "media/images/countryrect/bs-970bf0cc7b3780c5387a153113560172.svg";